import React, { useEffect, useState } from "react";
import "./MapWrapperForEdit.css";
import ModalComponent from "../../../../Components/UiComponents/ModalComponent/ModalComponent";
import CustomMapForEdit from "./CustomMapForEdit";

const MapWrapperForEdit = (props) => {
  const {
    containerStyles = {},
    bodyStyles = {},
    initialZoom = 12,
    autoZoom = true,
    height = "500px",
    chooseCoordinates,
    closeMapModal,
    coordinates = [],
    zoom = 13,
    popUpShow = false,
    title,
    bankEdit,
    atmEdit
  } = props;

  const [longitude, setLongitude] = useState("");
  const [latitude, setLatitude] = useState("");
  const [selectedCoordinates, setSelectedCoordinates] = useState([]);

  // Initialize the map with provided coordinates
  useEffect(() => {
    if (coordinates && coordinates.length > 0) {
      // Assuming coordinates are in the format expected by the map
      setSelectedCoordinates(coordinates);
      // If there's at least one coordinate, set longitude and latitude
      if (coordinates[0]) {
        if (coordinates[0].y !== undefined && coordinates[0].x !== undefined) {
          setLongitude(coordinates[0].y);
          setLatitude(coordinates[0].x);
        } else if (Array.isArray(coordinates[0]) && coordinates[0].length >= 2) {
          // Handle array format [lng, lat]
          setLongitude(coordinates[0][0]);
          setLatitude(coordinates[0][1]);
        }
      }
    }
  }, [coordinates]);

  const handleChooseCoordinates = (longitude, latitude) => {
    setLongitude(longitude);
    setLatitude(latitude);
    setSelectedCoordinates([{ x: latitude, y: longitude }]); // [lat, lng]
    if (chooseCoordinates) {
      chooseCoordinates(longitude, latitude);
    }
  };

  useEffect(() => {
    if (longitude && latitude) {
      setSelectedCoordinates([{ x: latitude, y: longitude }]);
    }
  }, [longitude, latitude]);

  const [showExpand, setShowExpand] = useState(false);
  const expandHandler = () => {
    setShowExpand(!showExpand);
  };

  const renderMap = () => (
    <CustomMapForEdit
      chooseCoordinates={handleChooseCoordinates}
      closeMapModal={closeMapModal}
      coordinates={selectedCoordinates}
      initialZoom={initialZoom}
      autoZoom={autoZoom}
      zoom={zoom}
      popUpShow={popUpShow}
      bankEdit={bankEdit}
    />
  );

  return (
    <div
      className="map__container"
      style={{
        ...containerStyles,
        borderRadius: "8px",
        overflow: "hidden",
        height: atmEdit ? "600px" : height,
      }}
    >

      <div
        className="map__container--body"
        style={{
          ...bodyStyles,
          height: title ? "calc(100% - 40px)" : "100%",
          width: "100%",
        }}
      >
        {renderMap()}
      </div>

      {showExpand && (
        <ModalComponent
          title="Map View"
          show={showExpand}
          handleToggle={expandHandler}
          fullscreen={true}
          component={renderMap()}
        />
      )}
    </div>
  );
};

export default MapWrapperForEdit;